module.exports = __webpack_public_path__ + "img/cover-01.a688925b.jpg";